import { render, staticRenderFns } from "./recordLists.vue?vue&type=template&id=014495a2&scoped=true&"
import script from "./recordLists.vue?vue&type=script&lang=js&"
export * from "./recordLists.vue?vue&type=script&lang=js&"
import style0 from "./recordLists.vue?vue&type=style&index=0&id=014495a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014495a2",
  null
  
)

export default component.exports